import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import { downloadService } from 'services';
import { useNotifications } from 'shared/hooks';

const useStyle = makeStyles(theme => ({
  button: {
    textTransform: 'none',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    borderRadius: 16,
    height: 32,
  },
}));

const DownloadButton = ({ url, directDownload, fileName, children, ...props }) => {
  const classes = useStyle();
  const { notifyError } = useNotifications();
  const { t } = useTranslation();
  const [isPending, setIsPending] = useState(false);

  const downloadErrorHandler = () => {
    notifyError(t('Failed to download the file'));
  };

  const handleClick = () => {
    if (directDownload) {
      setIsPending(true);
      downloadService({ path: url, name: fileName, onError: downloadErrorHandler }).finally(() => {
        setIsPending(false);
      });
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <Button
      {...props}
      className={classes.button}
      size="small"
      variant="outlined"
      onClick={handleClick}
      disabled={isPending}
    >
      {!isPending ? children : t('Downloading...')}
    </Button>
  );
};

DownloadButton.defaultProps = {
  directDownload: false,
  fileName: '',
};

DownloadButton.propTypes = {
  url: PropTypes.string.isRequired,
  directDownload: PropTypes.bool,
  fileName: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default DownloadButton;
